import React from 'react'
import { Box, Typography } from '@mui/material'
import ActionBar from '../components/ActionBar'

/**
 * Página inicial / Fluxos.
 * Conteúdo mínimo até o usuário definir a rotina de fluxos.
 */
const FluxosPage: React.FC = () => {
  return (
    <Box sx={{ width: '100%', display: 'flex', flexDirection: 'column', gap: 3, p: 2 }}>
      <ActionBar />
      <Box sx={{ py: 4, textAlign: 'center' }}>
        <Typography variant="body1" color="text.secondary">
          Use o menu à esquerda para acessar as funcionalidades.
        </Typography>
      </Box>
    </Box>
  )
}

export default FluxosPage
